/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.12",
    versionName: "0.2.0-nightly.2026.1.12",
    versionChannel: "nightly",
    buildDate: "2026-01-12T00:07:53.617Z",
    commitHash: "1f7364d6c731087187a29f68bdd706d8e1e8ea83",
};
